import type { Meta, StoryFn } from '@storybook/react';
import type { SliderProps } from './Slider';

import { Slider } from './Slider';

const codeString =
  '<Slider min={number} max={number} value?={number} step?={number} units?={string} onChange?={(value: number) => void} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Slider',
  component: Slider,
  argTypes: {
    onChange: {
      action: 'Slider value',
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Slider,
    codeString: codeString,
  },
} as Meta<SliderProps>;

const Template: StoryFn<SliderProps> = (args) => {
  const handleSliderChange = (value: number) => {
    if (args.onChange) {
      args.onChange(value);
    }
  };

  return (
    <>
      <div style={{ width: '150px' }}>
        <Slider {...args} onChange={handleSliderChange} />
      </div>
      <div style={{ width: '300px', marginTop: '40px' }}>
        <Slider {...args} onChange={handleSliderChange} value={40} />
      </div>
      <div style={{ width: '600px', marginTop: '40px' }}>
        <Slider {...args} onChange={handleSliderChange} value={60} />
      </div>
    </>
  );
};

export const SliderExample = Template.bind({});
SliderExample.args = {
  min: 0,
  max: 100,
  step: 5,
  units: '%',
  value: 80,
};
